/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smpte_Format_PlaceholderInputs */



/**
* | output |
* | --- |
* | "SMPTE Format (e.g. hh:mm:ss:ff)" |
*
* @param {Smpte_Format_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const smpte_format_placeholder = /** @type {((inputs?: Smpte_Format_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smpte_Format_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format SMPTE (ex. hh:mm:ss:ff)")
	if (locale === "de") return /** @type {LocalizedString} */ ("SMPTE-Format (z. B. hh:mm:ss:ff)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato SMPTE (ad esempio hh:mm:ss:ff)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Формат SMPTE (например, hh:mm:ss:ff)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato SMPTE (p. ej. hh:mm:ss:ff)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("SMPTE 格式（例如 hh:mm:ss:ff）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("SMPTE形式（例：hh:mm:ss:ff）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("SMPTE प्रारूप (उदाहरण के लिए hh:mm:ss:ff)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formato SMPTE (ex.: hh:mm:ss:ff)")
	return /** @type {LocalizedString} */ ("SMPTE Format (e.g. hh:mm:ss:ff)")
});